import { Card, Descriptions, Tag, Empty } from "antd";
import { Fragment, ReactNode } from "react";

type InfoItem = {
  label: string;
  value: string | ReactNode;
  type?: "text" | "tag";
};

interface InfoCardProps {
  title: string;
  icon?: ReactNode;
  items?: InfoItem[];
}

export const InfoCard = ({ title, icon, items }: InfoCardProps) => {
  const hasItems = items && items.length > 0;

  return (
    <Card
      className="bg-gradient-to-r from-gray-50 to-white rounded-xl shadow-sm 
                 [&_.ant-card-body]:px-6 [&_.ant-card-body]:py-4 
                 [&_.ant-card-head-title]:text-gray-800 [&_.ant-card-head-title]:font-semibold"
      title={
        <span>
          {icon && <span className="mr-2">{icon}</span>}
          {title}
        </span>
      }
    >
      {hasItems ? (
        <Descriptions
          column={1}
          className="mt-4 [&_.ant-descriptions-item-label]:font-semibold 
                     [&_.ant-descriptions-item-label]:text-gray-700 
                     [&_.ant-descriptions-item-label]:w-[140px]"
        >
          {items!.map((item, idx) => (
            <Fragment key={idx}>
              <Descriptions.Item label={item.label}>
                {item.label === "Status" ? (
                  <Tag
                    className={`px-3 py-1 rounded font-medium text-sm border-none ${
                      item.value === "ACTIVE"
                        ? "bg-green-100 text-green-700"
                        : item.value === "INACTIVE"
                        ? "bg-red-100 text-red-700"
                        : item.value === "DEACTIVATE"
                        ? "bg-yellow-100 text-yellow-700"
                        : "bg-gray-100 text-gray-500"
                    }`}
                  >
                    {item.value || "Not specified"}
                  </Tag>
                ) : item.type === "tag" ? (
                  <Tag className="bg-blue-50 text-blue-600 border-none rounded font-medium">
                    {item.value || "Not specified"}
                  </Tag>
                ) : (
                  <p className="text-gray-800 text-sm">
                    {item.value || "Not specified"}
                  </p>
                )}
              </Descriptions.Item>

              {/* Divider except last */}
              {idx < items!.length - 1 && (
                <div className="my-2 border-t border-gray-200"></div>
              )}
            </Fragment>
          ))}
        </Descriptions>
      ) : (
        <div className="py-6 flex justify-center">
          <Empty description="No information available" />
        </div>
      )}
    </Card>
  );
};
